/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var L,A;!function(L){L[L.USER=1]="USER",L[L.SCALE_RANGE=2]="SCALE_RANGE",L[L.FILTER=4]="FILTER",L[L.DECONFLICTION=8]="DECONFLICTION",L[L.ALL_GRAPHIC=15]="ALL_GRAPHIC",L[L.ALL_LABEL=255]="ALL_LABEL"}(L||(L={})),function(L){L[L.GRAPHIC=1]="GRAPHIC",L[L.LABEL=16]="LABEL"}(A||(A={}));export{L as VisibilityFlag,A as VisibilityGroup};
